import msg from "./msg";
export const debounce = (fn, interval) => {
  var timer;
  var gapTime = interval || 200; //间隔时间，如果interval不传，则默认200ms
  return function () {
    clearTimeout(timer);
    var context = this;
    var args = arguments; //保存此处的arguments，因为setTimeout是全局的，arguments不是防抖函数需要的。
    timer = setTimeout(function () {
      fn.call(context, args);
    }, gapTime);
  };
};
export const throttle = (fn, interval) => {
  var enterTime = 0; //触发的时间
  var gapTime = interval || 300; //间隔时间，如果interval不传值，默认为300ms
  return function () {
    var that = this;
    var backTime = new Date(); //第一次函数return即触发的时间
    if (backTime - enterTime > gapTime) {
      fn.call(that, arguments);
      enterTime = backTime; //赋值给第一次触发的时间 保存第二次触发时间
    }
  };
};
export const deepClone = function (obj) {
  let result = {}.toString.call(obj) === "[object Array]" ? [] : {};
  for (let key in obj) {
    let target = obj[key];
    let str = {}.toString.call(target);
    if (str === "[object Array]") {
      let arr = [];
      for (let i in target) {
        // 递归克隆数组中的每一项
        arr.push(deepClone(target[i]));
      }
      result[key] = arr;
    } else if (str === "[object Object]") {
      result[key] = deepClone(target);
    } else {
      result[key] = target;
    }
  }
  return result;
};
// 去重
export const distinct = function (arr, key) {
  if ({}.toString.call(arr) != "[object Array]") return arr;
  if (arr.length == 0) return arr;
  if ({}.toString.call(arr[0]) == "[object Object]") {
    let map = new Map();
    let result = [];
    arr.forEach(
      (val) => !map.has(val[key]) && map.set(val[key], true) && result.push(val)
    );
    return deepClone(result);
  } else {
    return Array.from(new Set(arr));
  }
};
export const exportFile = (url, fileName) => {
  if (!url) {
    msg.error("文件链接不能为空!");
    return false;
  } else if (!fileName) {
    msg.error("请填写文件名!");
    return false;
  }
  let arr = url.split(".");
  let type = arr[arr.length - 1];
  fileName = `${fileName}.${type}`;
  let xhr = new XMLHttpRequest();
  xhr.open("GET", url);
  xhr.responseType = "blob";
  xhr.onload = () => {
    let ctx = xhr.response;
    let blob = new Blob([ctx]);
    if ("msSaveOrOpenBlob" in navigator) {
      //兼容IE
      window.navigator.msSaveOrOpenBlob(blob, fileName);
    } else {
      let aLink = document.createElement("a");
      aLink.download = fileName;
      aLink.style.display = "none";
      aLink.href = URL.createObjectURL(blob);
      document.body.appendChild(aLink);
      aLink.click();
      document.body.removeChild(aLink);
    }
  };
  xhr.send();
};
export const alinkDownloadFile = path => {
  const alink = document.createElement('a')
  alink.style.display = 'none'
  alink.href = path
  alink.download = ''
  document.body.appendChild(alink)
  alink.click()
  URL.revokeObjectURL(alink.href) // 释放URL 对象
  document.body.removeChild(alink)
}
export const openRef = (link) => window.open(link);
